/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


const stg = {
    API_DOMAIN: 'https://api-stage.pearson.com/gps/',
    ALS_DOMAIN: 'https://preprod.pearsonactivelearn.com/',
    ALS_MARK_BOOK: 'app/reports/markbook/list',
    ENVIRONMENT: 'stg',
    CLIENT_ID: 'tuA9zGJNrumMCM8q6QtVHATVREuqj8RF',
    IES_BASE_URL: 'https://login-stg.pearson.com/v1/piapi-int/',
	LAUNDING_URL: 'https://gps-stg-insights.pearson.com/',
	
    ACADEMIC_YEAR_LIST: [{ "id": "2018", "label": "2018-2019" }, { "id": "2019", "label": "2019-2020" }, { "id": "2020", "label": "2020-2021" }, { "id": "2021", "label": "2021-2022" }]
    
    

};
export default stg;


    
   
 